import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

// Classes.
import {IndexItem} from '../../classes/indexItem';

@Component({
  selector: 'app-book',
  templateUrl: './book.component.html',
  styleUrls: ['./book.component.scss']
})
export class BookComponent implements OnInit {

  /**
   * An input for set the absolute route in ionic app.
   *
   * @type {string}
   * @memberof BookComponent
   */
  @Input() bookLink: string;

  @Input() book: IndexItem;

  /**
   * Property for set the view of appendix slices.
   *
   * @memberof BookComponent
   */
  numberOfSlicesAppendix = 2;
  /**
   * An output for set the title into the tab of ionic app.
   *
   * @memberof BookComponent
   */
  @Output() bookTitle = new EventEmitter<string>();

  public tab: string;
  public hasTabs: boolean;

  constructor() { }

  ngOnInit() {
    // Dont show tabs if only one option.
    if (this.book) {
      this.hasTabs = this.book.chapters.length > 0 && this.book.appendixes.length > 0;
      this.tab = this.book.chapters.length > 0 ? 'chapter' : 'appendix';
    }
  }

  public setTab(id: string) {
    this.tab = id;
  }

  /**
   * Method for increase the appendix of book.
   *
   * @memberof BookComponent
   */
  increaseAppendixSlice(){
    this.numberOfSlicesAppendix = this.numberOfSlicesAppendix + 2;
  }
}
